goog.provide("shadow.js.shim.module$src$svg$type$file_type$excel_csv_svg$default");
shadow.js.shim.module$src$svg$type$file_type$excel_csv_svg$default = shadow.js.shim.module$src$svg$type$file_type$excel_csv_svg.default;
